/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-08 11:27:26
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-08 11:43:10
 */
import wxShare from "weixin-share2";
import { IShareConfig, ITopShareConfig, IWxShareConfig } from "./interface";

const CodoonNativeBridge = window.WebNativeBridge;
export const bridge = new CodoonNativeBridge();

/**
 * 分享
 */

/* bridge 自定义分享 */
export const customerShare = (shareConfig: IShareConfig) => {
  bridge.nativeCustomerShare(shareConfig);
};

/* bridge 注册右上角分享内容 */
export const shareDefaultTop = (topShareConfig: ITopShareConfig) => {
  bridge.nativeTopButtonShare(topShareConfig);
};

/* 微信分享的配置 */
export const wxShareConfig = (wxShareConfig: IWxShareConfig) => {
  wxShare.config(wxShareConfig);
};

/**
 * @name 是否在咕咚App内
 * */
export const isInCodoon = () => {
  if (window.location.href.indexOf("isInCodoon") !== -1) {
    return true;
  }
  return bridge.isInCodoon;
};

/**
 * 注册回到页面时执行的函数
 */
export const addNativeReturnListener = (cb: Function) => {
  bridge.nativeSwitchNotice(cb);
};

/**
 * @name 跳转其他链接
 * */
export const jumpToWebView = (url: string, cb = () => {}) => {
  // bridge.hideTopShareButton()
  bridge.jumpNative(
    {
      type: "webView",
      value: url,
    },
    cb
  );
};

/**
 * 设置主题颜色
 * @barColor ?sting 背景颜色
 * @titleColor ?string 文字颜色
 */
export function setBarColor(barColor: string, titleColor: string) {
  bridge.nativeSetTitleBar({ title_color: titleColor, bar_color: barColor });
}
